import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const getPOListQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getVendorPOList, cleanedData);
};

const getVendorPoList = (data) => {
  return useQuery(['getVendorPOList', data],
    () => getPOListQuery(data), { refetchOnWindowFocus: false });
};

export default getVendorPoList;
